import { render, staticRenderFns } from "./AIModelDetail.vue?vue&type=template&id=c843dfa0&"
import script from "./ai-model-detail.js?vue&type=script&lang=js&"
export * from "./ai-model-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports